import { ReactNode } from 'react';

import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

import { cn } from '../../lib';

interface IPageHeaderSectionProps {
  customHeaderContent?: ReactNode;
  headerActions?: ReactNode;
  isHeaderBorderless?: boolean;
  subtitle?: TTextLocalized;
  title: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * Provides the page header section of a details page.
 */
export function PageHeaderSection({
  customHeaderContent,
  headerActions,
  isHeaderBorderless = false,
  title,
  subtitle,
}: IPageHeaderSectionProps) {
  return (
    <div
      className={cn(
        isHeaderBorderless ? ' py-8' : 'w-full border-b-[0.5] pb-4 pt-8'
      )}
    >
      <div
        className="
          @lg:px-6 @xl:px-12 @2xl:px-20 @3xl:px-24 mx-auto w-full max-w-[1200px]
          px-4
        "
      >
        <div
          className="
            flex flex-col items-start justify-between gap-4 transition-all
            duration-500 ease-in-out  md:flex-row lg:items-center
          "
        >
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              {customHeaderContent || (
                <div className="space-y-1">
                  <h1 className="scroll-m-20 text-3xl font-medium tracking-tight first:mt-0">
                    <Text className="truncate" text={title} />
                  </h1>

                  {subtitle ? (
                    <p className="text-body-text/80 lg:min-w-xl text-lg">
                      <Text text={subtitle} />
                    </p>
                  ) : null}
                </div>
              )}
            </div>
          </div>

          {headerActions || null}
        </div>
      </div>
    </div>
  );
}
